<template>
  <section class="home-start">
    <div class="background">
      <div class="start-overlay" />
    </div>
    <div class="logo">
      <b-img src="../../assets/images/logo.png"/>
    </div>
    <div class="header-area">
      <div class="content-box" >
        <div class="content">
          Was zunächst als kleiner Service rund um Haus und Garten begann, entwickelte sich im Laufe der Jahre zu einem großen Komplettservice. Nun besteht die Gartenfee bereits seit 1996.
          Wir sind ein Dienstleistungsunternehmen mit hohen Ansprüchen an unsere eigenen Leistungen, nur so können wir uns mit jedem Service, den wir Ihnen anbieten, identifizieren.

          Falls Sie Informationen vermissen sollten, schicken Sie uns doch bitte einfach  eine kurze E-Mail oder rufen Sie uns einfach an.
        </div>
      </div>
      <div class="image">
        <b-img class="welcome" src="../../assets/images/welcome.png"/>
      </div>
    </div>
  </section>
</template>

<script>
  export default {
    name: 'HomeStart',
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
  @import '../../assets/styles/home/start.scss';
</style>
